export default __webpack_public_path__ + "static/media/interactive-listmaker-thumbnail.c6faa924.png";